function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".voice_svg__f{fill:#fff}.voice_svg__e{stroke:#1d1f2c;stroke-linecap:round}.voice_svg__e,.voice_svg__f{stroke-width:2px}.voice_svg__e{fill:none}.voice_svg__f{stroke:#d32f2f}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.739 68.596a22.994 22.994 0 010-32.525L36.313 8.497A23 23 0 1168.84 41.022L41.264 68.596a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 10.758)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.758 41.242h7.485L42.237 59H28.764z",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#1d1f2c",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 -1.758)",
  strokeWidth: 2,
  stroke: "#1d1f2c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 66,
  height: 53,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 64,
  height: 51,
  rx: 5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__e",
  d: "M3.266 44h63.8M3.266 23h18.015M34.66 44v-9.391M48.602 23h17.453M34.66 11.394V-.914M20.5 59h29.911M35 47h.05"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.831 4.365)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M4.669 6.877h2a4.5 4.5 0 014.5 4.5.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5 4.5 4.5 0 014.5-4.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__f",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(2.169 -.123)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.831 26.77)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M4.669 7.472h2a4.5 4.5 0 014.5 4.5.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5 4.5 4.5 0 014.5-4.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__f",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(2.169 .472)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.585 4.365)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M3.915 6.877h2a4.5 4.5 0 014.5 4.5.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5 4.5 4.5 0 014.5-4.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__f",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(1.415 -.123)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.585 26.77)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M3.915 7.472h2a4.5 4.5 0 014.5 4.5.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5 4.5 4.5 0 014.5-4.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__f",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(1.415 .472)"
})), /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M39 20.242l4-1a1 1 0 011 1v5a1 1 0 01-1 1l-4-1a1 1 0 01-1-1v-3a1 1 0 011-1z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "voice_svg__f",
  width: 13,
  height: 11,
  rx: 2,
  transform: "translate(27 17.242)"
}));

var SvgVoice = function SvgVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgVoice as ReactComponent };